import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import { Input } from "components/bootstrap";
import FormDataContext from "integrations/contexts/FormDataContext";
import { AdvancedOptionsContext } from "integrations/aws/context/AdvancedOptions";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
const FormAdvancedOptions = ({ onChange, handleSqsMessageBatchSizeChange }) => {
  const { t } = useTranslation("integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { overrideSource, awsCloudTrailThrottleEnabled, sqsMessageBatchSize, includeFullMessageJson } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  const internalHandleSqsBatchSizeChange = (e) => {
    const { value } = e.target;
    onChange(e, formData);
    if (value >= 1 && value <= 10) {
      handleSqsMessageBatchSizeChange("");
    } else {
      handleSqsMessageBatchSizeChange(t("aws_cloudtrail_advanced_options.sqs_batch_size_error"));
    }
  };
  return /* @__PURE__ */ React.createElement(
    AdditionalFields,
    {
      title: t("aws_cloudtrail_advanced_options.title"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(
      ThrottlingCheckbox,
      {
        id: "awsCloudTrailThrottleEnabled",
        defaultChecked: awsCloudTrailThrottleEnabled == null ? void 0 : awsCloudTrailThrottleEnabled.value,
        onChange
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "overrideSource",
        type: "text",
        value: overrideSource == null ? void 0 : overrideSource.value,
        onChange,
        label: t("aws_cloudtrail_advanced_options.override_source_label"),
        help: t("aws_cloudtrail_advanced_options.override_source_help")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "sqsMessageBatchSize",
        type: "number",
        min: "1",
        value: sqsMessageBatchSize == null ? void 0 : sqsMessageBatchSize.value,
        onChange: internalHandleSqsBatchSizeChange,
        label: t("aws_cloudtrail_advanced_options.sqs_batch_size_label"),
        help: t("aws_cloudtrail_advanced_options.sqs_batch_size_help")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "includeFullMessageJson",
        type: "checkbox",
        checked: includeFullMessageJson == null ? void 0 : includeFullMessageJson.value,
        onChange,
        label: t("aws_cloudtrail_advanced_options.include_full_message_json_label"),
        help: t("aws_cloudtrail_advanced_options.include_full_message_json_help")
      }
    )
  );
};
export default FormAdvancedOptions;
